import { routes } from "@/routes/utils";

export const menuItems = [
  {
    title: "Home",
    to: routes.root,
  },
  {
    title: "About Us",
    to: routes.about,
    children: [
      {
        title: "Overview",
        to: `${routes.overview}`,
      },
      {
        title: "Our Leadership",
        to: `${routes.leadership}`,
      },
      {
        title: "Our History",
        to: `${routes.history}`,
      },
    ],
  },
  {
    title: "Our Solutions",
    to: routes.ourProducts,
  },
  // {
  //   title: "Research & Innovation",
  //   to: routes.researchInnovation,
  // },
  {
    title: "Updates",
    to: routes.update,
  },
  {
    title: "Blogs",
    to: routes.Blogs,
  },
  {
    title: "Careers",
    to: routes.career,
  },
  {
    title: "Contact Us",
    to: routes.contact,
  },
];
